export default "__VITE_ASSET__dWWu6oDJ__"